<template>
  <div class="border-neutral-95 mb-6 border bg-white sm:rounded-lg">
    <div class="flex justify-between overflow-hidden px-4 py-4 sm:p-6">
      <SendersManager />
    </div>
  </div>
</template>

<script setup lang="ts">
//Components
import SendersManager from "./SendersManager.vue";
</script>
